import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private isIpadSubject = new BehaviorSubject<boolean>(false);

  isIpad$ = this.isIpadSubject.asObservable();

  setIpadStatus(status: boolean) {
    this.isIpadSubject.next(status);
  }
}
